import { createFileRoute, notFound } from "@tanstack/react-router";
import { ComparisonLayout } from "@/components/ComparisonLayout";
import { getComparisonBySlug } from "@/lib/comparisons-data";
import { buildSeoMeta } from "@/lib/seo";

const SLUG = "shopify-vs-prestashop";

export const Route = createFileRoute("/porownanie/shopify-vs-prestashop")({
  head: () => {
    const c = getComparisonBySlug(SLUG)!;
    return buildSeoMeta({
      title: c.title,
      description: c.metaDescription,
      path: `/porownanie/${SLUG}`,
    });
  },
  component: () => {
    const c = getComparisonBySlug(SLUG);
    if (!c) throw notFound();
    return <ComparisonLayout data={c} />;
  },
});
